angular
	.module 'App.Repository'
	.factory 'InfrasecRepository', ['BaseRepository', (BaseRepository) ->
		class InfrasecRepository extends BaseRepository
			@resource = '/integrations/infrasec'
			@isRestricted = true

			openRegister: (id) ->
				@put "register/#{id}/open"

			closeRegister: (id) ->
				@put "register/#{id}/close"

			registerStatus: (id) ->
				@findById "register/#{id}/status"

			enrollRegister: (id) ->
				@post "register/#{id}/new"

			status: ->
				@find "status"

			setStatus: (status) ->
				if status
					@post "activate"
				else
					@post "deactivate"

		return new InfrasecRepository
	]
